import type { FormErrors } from 'redux-form';

const flatten = (arr: Array<any>): Array<any> =>
  arr.reduce(
    (flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );

const getErrorFieldNames = (obj: FormErrors<FormData, string>, name = ''): Array<string> => {
  const errorArr = [];
  errorArr.push(
    Object.keys(obj)
      .map((key) => {
        const next = obj[key];
        if (next) {
          if (typeof next === 'string' || (next._error && typeof next._error === 'string')) {
            return name + key;
          }
          if (Array.isArray(next)) {
            errorArr.push(
              next
                .map((item, index) => getErrorFieldNames(item, `${name}${key}[${index}].`))
                .filter(Boolean)
            );
          }
        }
        return null;
      })
      .filter(Boolean)
  );
  return flatten(errorArr);
};

const scrollToError = (errors: FormErrors<FormData, string>) => {
  if (!errors) {
    return;
  }

  const errorFields = getErrorFieldNames(errors);

  errorFields.some((fieldName) => {
    const elements = document.querySelectorAll(`[name="${fieldName}"]`);
    if (elements.length) {
      window.scrollTo(
        0,
        elements[0].getBoundingClientRect().top + document.documentElement.scrollTop - 150
      );
      return true;
    }
    return false;
  });
};

export { scrollToError };
